export const getters = {
   systemFileopenings: state => state.files,
   systemFileopeningss: state => state.fileopenings,
   Fileopening: state => state.systemFileopening,
   Filenumber: state => state.file_no
}
export default getters



// WEBPACK FOOTER //
// ./src/vuex/modules/fileopenings/getters.js